import { IInfoCategoryMasterData } from '@Domains/MasterData';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { useFormContext } from 'react-hook-form';

type CheckboxListProps = {
  name: string;
  filter: IInfoCategoryMasterData[];
  disabled?: boolean;
};

const FormCheckboxList = ({ name, filter, disabled }: CheckboxListProps) => {
  const { getValues, setValue } = useFormContext();
  const selectedValue = getValues(name) || [];

  const isChecked = (nameTh: string) => {
    return selectedValue.some(
      (item: IInfoCategoryMasterData) => item.nameTh === nameTh
    );
  };

  const handleCheckboxChange = (nameTh: string, checked: boolean) => {
    const currentValues = getValues(name) || [];

    const updatedValues = checked
      ? addStakeholder(nameTh, currentValues)
      : removeStakeholder(nameTh, currentValues);

    setValue(name, updatedValues);
  };

  const addStakeholder = (
    nameTh: string,
    currentValues: IInfoCategoryMasterData[]
  ) => {
    const selectedOption = filter.find((option) => option.nameTh === nameTh);

    const newStakeholder = {
      nameTh,
      nameEn: selectedOption?.nameEn || '',
      infoCategoryMasterDataId: selectedOption?.id || '',
    };

    return [...currentValues, newStakeholder];
  };

  const removeStakeholder = (
    nameTh: string,
    currentValues: IInfoCategoryMasterData[]
  ) => {
    return currentValues.filter((item) => item.nameTh !== nameTh);
  };

  return (
    <Box
      maxHeight={'250px'}
      p={1}
      border={'1px solid rgba(0, 0, 0, 0.12)'}
      borderTop={'none'}
      sx={{
        overflowY: 'auto',
        overflowX: 'hidden',
        borderBottomLeftRadius: '4px',
        borderBottomRightRadius: '4px',
      }}
    >
      {filter.map((option) => (
        <FormControlLabel
          key={option.id}
          control={
            <Checkbox
              disabled={disabled}
              checked={isChecked(option.nameTh)}
              onChange={(e) =>
                handleCheckboxChange(option.nameTh, e.target.checked)
              }
            />
          }
          label={option.nameTh}
          sx={{
            width: '100%',
          }}
        />
      ))}
    </Box>
  );
};

export default FormCheckboxList;
